<template>
    <section id="home" class="relative min-h-screen flex items-center justify-center bg-slate-900 overflow-hidden pt-14">
      <!-- Animated Background -->
      <div class="absolute inset-0 overflow-hidden">
        <div class="absolute -top-40 -right-40 w-80 h-80 bg-emerald-500/10 rounded-full blur-3xl"></div>
        <div class="absolute -bottom-40 -left-40 w-80 h-80 bg-teal-500/10 rounded-full blur-3xl"></div>
        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl"></div>
      </div>
      
      <div class="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div class="mb-8">
          <div class="inline-block">
            <div class="w-36 h-36 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 p-1">
              <div class="w-full h-full rounded-full bg-slate-900 flex items-center justify-center">
                <span class="text-4xl font-bold text-emerald-400">WW</span>
              </div>
            </div>
          </div>
        </div>
        
        <p class="text-emerald-400 text-sm font-semibold tracking-widest uppercase mb-4">Welcome to my portfolio</p>
        
        <h1 class="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Hi, I'm <span class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Wendm Werku</span>
        </h1>
        
        <p class="text-xl sm:text-2xl text-slate-400 mb-4 font-light">
          Full-Stack Software Developer
        </p>
        
        <p class="text-base sm:text-lg text-slate-500 max-w-2xl mx-auto mb-10 leading-relaxed">
        I create end-to-end software solutions, turning ideas into well-structured, maintainable, and impactful products.
        </p>
        
        <div class="flex flex-col sm:flex-row justify-center gap-4">
          <a href="#projects" class="group px-8 py-4 bg-emerald-500 text-white rounded-lg font-semibold hover:bg-emerald-600 transition-all duration-300 shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/40">
            View My Work
            <span class="inline-block ml-2 group-hover:translate-x-1 transition-transform">&rarr;</span>
          </a>
          <!-- Added Resume Download Button -->
          <a href="/resume.pdf" download class="px-8 py-4 bg-transparent text-white border border-slate-600 rounded-lg font-semibold hover:border-emerald-500 hover:text-emerald-400 transition-all duration-300 flex items-center justify-center gap-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download Resume
          </a>
        </div>
        
        <!-- Scroll Indicator -->
        <div class="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <svg class="w-6 h-6 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
</template>
